import React from 'react';
import CommonSelect from '../../../Common/Controller/Select';
import {
  STATUS_FORM_OPTION_LIST,
  TRUCK_DAMAGE_CHECKBOX_FIRST_OPTION_LIST,
} from '../../../../constant/Safety/DamageReport/options';
import StyledCheckBoxArea from '../../../../style/Safety/DamageReport/StyledCheckBoxArea';
import CommonDamageCheckBox from '../CommonDamageCheckBox';
import { handleInputChange } from '../../../../util/Safety/DamageReport/Handler/changedInputHandler';
import {
  OTHER_INPUT_STYLE,
  STYLE_TRUCK_STATUS_CHECKBOX_AREA,
} from '../../../../style/Safety/DamageReport/styles';
import { DAMAGE_STATUS } from '../../../../constant/Safety/DamageReport/standardCodes';
import CustomTextarea from '../../../Common/Controller/Textarea/Custom';

const TruckDamagedInfoFields = ({ isCompleted, damageReport, isEditable }) => {
  return (
    <div className="flex flex-col w-full mt-[-1px]">
      <div className="w-full">
        <div className="w-[112px]">
          <CommonSelect
            label="STATUS"
            option={STATUS_FORM_OPTION_LIST}
            inputName="status"
            disabled={isCompleted || !isEditable}
            onChangeHandler={handleInputChange}
            defaultValue={damageReport?.status || DAMAGE_STATUS?.DAMAGED}
          />
        </div>
      </div>
      <div className="w-full mt-[-1px]">
        <StyledCheckBoxArea styles={{ ...STYLE_TRUCK_STATUS_CHECKBOX_AREA }}>
          <div>
            <CommonDamageCheckBox
              options={TRUCK_DAMAGE_CHECKBOX_FIRST_OPTION_LIST}
              disabled={isCompleted || !isEditable}
            />
          </div>
          <div className="flex mt-[16px] items-center gap-x-[7px]">
            <CustomTextarea
              label="Other"
              inputName="trk_others"
              maxLength={120}
              suppressErrorVisible
              suppressErrorContentVisible
              styles={OTHER_INPUT_STYLE}
              disabled={isCompleted || !isEditable}
              onChange={handleInputChange}
              defaultValue={damageReport?.trk_others || ''}
              suppressCountVisible
            />
          </div>
        </StyledCheckBoxArea>
      </div>
    </div>
  );
};

export default TruckDamagedInfoFields;
